import React from "react";
import { LegalLayout } from "./LegalLayout";

export default function CreditsPolicy() {
  return (
    <LegalLayout
      slug="credits-policy"
      title="Credits Policy"
      lastUpdated="September 08, 2026"
      sections={[
        { heading: "What Are Credits", body: [
          `Credits are the internal unit of value used on AdGen Store (https://adgen.store). Each AI generation consumes a defined number of credits based on the model, resolution, and duration selected.`,
        ]},
        { heading: "How Credits Are Earned or Purchased", body: [
          `New accounts receive a signup bonus of credits. Additional credits can be purchased in packs or included as part of a subscription plan. [PLACEHOLDER — insert current signup bonus amount and confirm whether referral or promotional credit mechanics exist.]`,
        ]},
        { heading: "Credit Consumption", body: [
          `Credits are reserved when a generation is initiated and are only committed (deducted) if the generation succeeds. If a generation fails, reserved credits are automatically released back to your account. [PLACEHOLDER — confirm this matches actual system behavior with your engineering team.]`,
        ]},
        { heading: "Expiration", body: [
          `[PLACEHOLDER — specify whether credits expire, e.g. "Free/promotional credits expire after 90 days of inactivity; purchased credits do not expire" or similar, and how expiration will be communicated to users in advance.]`,
        ]},
        { heading: "Non-Refundable Nature", body: [
          `Purchased credits are non-refundable and non-transferable between accounts, except where required by applicable law or as described in our Terms of Paid Services. [PLACEHOLDER — replace with reviewed legal text]`,
        ]},
        { heading: "Usage Rules", body: [
          `Credits may only be used within the account that purchased or earned them, and only on the AdGen Store service.`,
          `Reselling, transferring, or pooling credits across multiple accounts without our written permission is prohibited. [PLACEHOLDER — replace with reviewed legal text]`,
        ]},
        { heading: "Suspension & Forfeiture", body: [
          `If your account is suspended or terminated for violating our Terms of Service or Community Guidelines, unused credits may be forfeited without refund. [PLACEHOLDER — replace with reviewed legal text]`,
        ]},
        { heading: "Changes to Pricing", body: [
          `We may adjust the credit cost of individual generations, or the price of credit packs and subscription plans, at any time with reasonable advance notice. [PLACEHOLDER — specify minimum notice period.]`,
        ]},
        { heading: "Contact", body: [
          `Name : AdGen Store Team\nAddress: Sunworld Arista, Sector-168, Noida, Uttar Pradesh, India\nEmail: adgenstore@gmail.com`,
        ]},
      ]}
    />
  );
}
